import { type BlockConfiguration,registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { OrderDetailsEdit } from './edit';
import { Icon } from './icon';
import type { OrderDetailsAttributes } from './types';

registerBlockType( metadata.name, {
	...( metadata as BlockConfiguration< OrderDetailsAttributes > ),
	icon: Icon,
	edit: OrderDetailsEdit,
} );
